const NoPage = () => {
  
    return (
      <div className="body">
        <h1>404</h1>
      </div>
      )
    };
    
    export default NoPage;